import { gql } from '@apollo/client';
import { USER_WITH_MATCHED_FAMILY } from '../fragments/User'; // Adjust the path as needed

export const SAVE_USER_SPOUSE_EMAIL = gql`
  mutation SaveUserSpouseEmail($spouseEmailInput: String!) {
    saveUserSpouseEmail(input: $spouseEmailInput) {
      ...UserWithMatchedFamilyFields
    }
  }
  ${USER_WITH_MATCHED_FAMILY}
`;